// extracted by mini-css-extract-plugin
export var checkMark = "CheckMark-module--checkMark--c423a";
export var checked = "CheckMark-module--checked--30676";
export var fadeInAnimation = "CheckMark-module--fadeInAnimation--596b5";
export var md = "CheckMark-module--md--9e31c";
export var sm = "CheckMark-module--sm--41799";